import { render, staticRenderFns } from "./StatisticsForGame.vue?vue&type=template&id=088fae1c&"
import script from "./StatisticsForGame.vue?vue&type=script&lang=js&"
export * from "./StatisticsForGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports